import { DrawerModal } from '@fagmobler/ui';
import Link from 'next/link';
import { ServerProduct } from '@/lib/janitsjar/Product';

type External3DLinkProps = {
  openedModal: string | null;
  closeModal: () => void;
  product: ServerProduct;
};

export const External3DLinkModalKey = 'external_3d_link';

export default function External3DLink({
  openedModal,
  closeModal,
  product,
}: External3DLinkProps) {
  return (
    <DrawerModal
      isOpen={openedModal === External3DLinkModalKey}
      onClose={closeModal}
      title="Valgmuligheter"
    >
      <div className="p-4 md:p-6 flex flex-col gap-4 md:gap-6 items-start">
        <div className="flex flex-col gap-4 md:gap-2">
          <h1 className="hd-base">Bygg dine egne møbler i 3D</h1>
          <p className="body-sm text-neutral-70">
            Våre tilpassede møbler lar deg velge farge, stoff og mer via vår
            produktside og katalog. Utforsk serier for å finne komplementære
            stykker, og ta kontakt for bestilling og personlig konsultasjon for
            å realisere drømmemøblene dine.
          </p>
        </div>
        {product.external3DLink && (
          <Link
            className="rounded bg-neutral-80 px-3 py-2.5 cap-xs font-bold text-neutral-0"
            href={product.external3DLink}
          >
            Gå til Møbelbygger
          </Link>
        )}
      </div>
    </DrawerModal>
  );
}
